<template>
  <div class="animated fadeIn">
    <quick-setup @refresh="refresh" v-if="is_first" @count="x => this.$emit('count', x)"></quick-setup>
    <b-row v-else>
      <b-col lg="12" :xl="isLoadPolicy ? 8 : 12">
        <b-card>
          <div slot="header">
            <strong>Site Info</strong>
            <span v-if="!add && model.created_at">( Registered : {{model.created_at | sdate}})</span>
            <span class="float-right" v-if="!add && model.last_visit">Last Visit : {{model.last_visit | utcsdate}}</span>
            <span class="float-right" v-else> - </span>
          </div>
          <b-row>
            <b-col md="2" v-if="add" style="cursor:pointer">
              <b-form-group label="Start with registration" label-for="ph_use" v-b-tooltip.hover title="Start site registration and check">
                <c-switch color="info" label size="sm" v-model="model.is_start" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Enable" label-for="ph_use" v-b-tooltip.hover title="Set scan enable or disable">
                <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="5">
              <b-form-group>
                <label for="ph_username" v-b-tooltip.hover title="Specifies the name that separates the site">
                  Name
                  <i style="cursor:pointer" class="fa fa-question-circle"></i>
                </label>
                <b-form-input placeholder="Auto Fill when write FQDN input" type="text" id="ph_name" v-model="model.name" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3" v-show="!lock">
              <b-form-group>
                <label for="ph_schedule_type" v-b-tooltip.hover title="Specify a check policy, the policy must be pre-generated">
                  Check Policy <i style="cursor:pointer" class="fa fa-question-circle"></i>
                </label>
                <b-form-select v-model="model.policy_id" @change="change($event)" :disabled="lock" ref="policy">
                  <option v-for="item in policy_list" :key="item.id" :value="item.id">{{item.description ? item.description : item.policy.description}}</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3" v-show="!add && lock">
              <b-form-group>
                <label v-b-tooltip.hover title="Specify a check policy, the policy must be pre-generated">
                  Check Policy <i style="cursor:pointer" class="fa fa-question-circle"></i>
                </label>
                <p>{{policy.description}}</p>

              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <b-form-group>
                FQDN : ex) www.f1security.co.kr : www(host) + f1security.co.kr(domain)
                <hr>
                <b-input-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> FQDN </b-input-group-text></b-input-group-prepend>
                  <b-form-input class="text-center border" type="text" ref="fqdn" id="ph_fqdn" placeholder="FQDN (ex : www.company.com)" v-model="model.fqdn" :plaintext="lock" @change="check_fqdn"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <label
                style="cursor:pointer"
                @click="msg = 'URLs to be checked or main pages to be checked or URLs of pages to be checked.'; modal_explain = true"
              >
                Check Start URL (max 10)
                <i class="fa fa-question-circle"></i>
              </label>
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend><b-input-group-text> Start From </b-input-group-text></b-input-group-prepend>
                  <b-form-input id="ph_seed" v-model="v.seed" type="url" placeholder="Full URL, ex) https://f1security.co.kr" @keyup.native.enter="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(seed, index) in model.config.seeds" :key="index"><i class="fa fa-times" @click="remove_seed(seed)" v-show="!lock"></i> {{seed}}</b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label
                  style="cursor:pointer"
                  @click="msg = 'Set the inspection cycle, It is recommended that you check at least once a day at a time when there are fewer people accessing the site.'; modal_explain = true"
                >
                  Check Schedule
                  <i
                  style="cursor:pointer"
                  class="fa fa-question-circle"
                  ></i>
                </label>
                <small>Max :{{max_schedule}}</small>
                <hr>
                * <b-badge variant="warning">Notice</b-badge>
                : For a your site availability, limit the maximum number of checks per day
                <hr>
                <b-input-group>
                  <b-form-select ref="schedule" id="ph_schedule" v-model="s.h" :options="s.h_opt" :disabled="lock" @change="schedule($event, 'h')"></b-form-select>
                  <b-form-select v-model="s.m" :options="s.m_opt" :disabled="lock" @change="schedule($event, 'm')"></b-form-select>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_schedule" :disabled="lock || (model.schedule.length >= max_schedule)">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <!-- // TODO : 나중에 크론 문법 아는 사람들을 위해 제공 예정 -->
              <!-- <b-form-group>
                <b-input-group>
                    <b-input-group-prepend><b-input-group-text>Custom Schedule(Use Cron Grammar) </b-input-group-text></b-input-group-prepend>
                    <b-form-input id="ph_schedule_custom" v-model="s.schedule_custom" type="text" placeholder="ex) 0 0 * * * *" @keyup.native.enter="add_schedule_custom" :disabled="lock || (model.schedule.length >= max_schedule)"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_schedule_custom" :disabled="lock || (model.schedule.length >= max_schedule)">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(schedule, index) in model.schedule" :key="index">
                    <i class="fa fa-times" @click="remove_schedule(schedule)" v-if="!lock"></i>
                    ({{ schedule }}) {{ schedule | cron_filter }}
                  </b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <strong>Additional information</strong>
          <hr>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label
                  style="cursor:pointer"
                  for="ph_sub_domain"
                  @click="msg = 'Register if subdomain exists within the same site ex) admin.f1security.co.kr'; modal_explain = true"
                >
                  Sub Domain
                  <i class="fa fa-question-circle"></i>
                </label>
                <b-input-group>
                  <b-form-input id="ph_sub_domain" v-model="v.sub" type="text" ref="sub_domains" placeholder="Domain" @keyup.native.enter="add_sub" :disabled="lock || (model.config.subs.length >= 100)"></b-form-input>
                  <b-button variant="primary" @click="add_sub" :disabled="lock || (model.config.subs.length >= 100)">Add</b-button>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(sub, index) in model.config.subs" :key="index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_sub(sub)"></i> {{sub}}</b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label
                  style="cursor:pointer"
                  for="ph_prevent"
                  @click="msg = 'Specifies the path to which the exception should be processed ex)/admin/download'; modal_explain = true">
                  Exception Path
                  <i class="fa fa-question-circle"></i>
                </label>
                <b-input-group>
                  <b-form-input id="ph_prevent" v-model="v.prevent" ref="prevent" type="text" placeholder="subroutine path" @keyup.native.enter="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(prevent, index) in model.config.prevents" :key="index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_prevent(prevent)"></i> {{prevent}}</b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <template v-if="lock">
            <template v-if="model.is_del">
              <b-button size="sm" variant="success" @click="revive"> Recover </b-button>
              <span>Recover</span>
            </template>
            <template v-else>
              <b-button size="sm" variant="primary" @click="edit"> Edit </b-button>
              <b-button size="sm" variant="danger" @click="del_confirm = true"> Remove </b-button>
            </template>
          </template>
          <template v-else>
            <b-button size="sm" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> Save </b-button>
            <b-button size="sm" variant="default" @click="cancel"> Cancel </b-button>
          </template>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>
        </b-card>
      </b-col>
      <!-- policy start -->
      <b-col lg="12" xl="4" v-if="isLoadPolicy">
        <b-card>
          <div slot="header">
            <strong>Policy</strong>
            <small class="float-right">info read only</small>
          </div>
          <b-row class="text-center">
            <b-col md="12">
              <span block class="h5">{{ isLoadPolicy ?  policy.description : '-'}}</span>
              <hr>
              <small>
                This page is Only showing policy information, can change on policy edit page.
              </small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> Maximum path depth </b-input-group-text></b-input-group-prepend>
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_depth" :min="1" :max="100" v-model="policy.depth" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> Sub Page Link </b-input-group-text></b-input-group-prepend>
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1" :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> Maximum Navigation Page </b-input-group-text></b-input-group-prepend>
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10" :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> TimeOut(Seceond) </b-input-group-text></b-input-group-prepend>
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1" :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> Check Speed(Millisecond) </b-input-group-text></b-input-group-prepend>
                  <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0" :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <template>
            <b-button block size="sm" variant="success" @click="policy_manage"> Manage </b-button>
          </template>
        </b-card>
        <!-- result start -->
        <b-card>
          <div slot="header" class="text-center">
            <strong v-if="result.page_count > 0">Have the latest inspection results.</strong>
            <strong v-else>don't have a recent check history. </strong>
          </div>
            <template>
              <b-button :disabled="!(result.page_count > 0)" block size="sm" variant="warning" @click="confirm_result = true"> Check it </b-button>
            </template>
          </b-card>
          <b-card>
            <div slot="header" class="text-center">
              <span>Displays whether login checks are enabled </span>
            </div>
              <template>
                <b-button :disabled="!is_using_login" block size="sm" :variant="is_using_login ? 'success' : 'light'"> {{ is_using_login ? 'Enable' : 'Disable' }} </b-button>
              </template>
            </b-card>
        </b-col>
    </b-row>
    <!-- delete modal -->
    <b-modal title="Delete"  class="modal-danger" v-model="del_confirm" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> Delete registered sites for checks </p>
      <p>
        If it is deleted, it is not possible to check the distribution location of the malicious code and its suspension.
      </p>
      <p> Are you sure you want to delete it? </p>
      <p> <b> * Check Site Name </b> </p>
      <p> Delete Site Name : {{model.name}}  </p>
      <b-form-input v-model="del_nickname" placeholder="Typing The name of the server you want to unregister"></b-form-input>
    </b-modal>
    <!-- result modal -->
    <b-modal size="xl" title="Site Result"  class="modal-primary" v-model="confirm_result" hide-footer @ok="confirm_result = false" ok-variant="primary">
      <result :result_id="result.id" :site="model"></result>
    </b-modal>
    <!-- modal -->
    <b-modal size="xs" title="Information"  header-bg-variant="info" v-model="modal_explain" hide-footer ok-variant="success">
      {{msg}}
    </b-modal>
    <b-modal v-model="modal_charge_agree" title="Controls all agents" @ok="charge_agree" no-close-on-backdrop header-bg-variant="warning">
      <h5>Charging will begin when the first site registration is made and scanning started.</h5>
      <hr>
      <a target="_blank" :href="redir" class="card-link">
        <span class="text-dark">See More</span>
        <i class="fa fa-share"></i>
        {{redir}}
      </a>
      <hr>
      <h6> <b>Are you sure argree?</b></h6>
    </b-modal>
  </div>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue';
import { Api } from '@/service';
import punycode from 'punycode';
import result from  '../result/Result.Detail'
import QuickSetup from  './Site.Quick.Setup'
import reg from '@/reg';
import codes from '@/codes';
import _ from 'lodash';

// 초기 필요한 데이터 시작
const default_model = () => ({
  is_alive: true, is_cron: false, is_start: true, is_js: true,
  schedule: [], config: { seeds : [], subs: [], prevents: [] }
});

const policy = {
  S : { depth: 5, links: 20, limit: 200 },
  M : { depth: 10, links: 50, limit: 2000 },
  L : { depth: 20, links: 100, limit: 10000 }
}

let h_opt = [
  { value: '*', text: 'every hour' },
  { value: '*/2', text: '2 hour interval'},
  { value: '*/3', text: '3 hour interval'},
  { value: '*/4', text: '4 hour interval'}
];
for(let i = 0; i < 24; i++) { h_opt.push({ value: i.toString(), text: i + ' hour' }); }

let m_opt = [
  { value: '*', text: 'every min' },
  { value: '*/5', text: '5 min interval'},
  { value: '*/10', text: '10 min interval'},
  { value: '*/15', text: '15 min interval'},
  { value: '*/20', text: '20 min interval'},
  { value: '*/30', text: '30 min interval'},
  { value: '*/45', text: '45 min interval'}
];
for(let i = 0; i < 60; i++) { m_opt.push({ value: i.toString(), text: i + ' min' }); }

// 초기 필요한 끝

export default {
  props : ['is_first'],
  components: { cSwitch, result, QuickSetup },
  filters: {
    cron_filter: function (v) {
      if (!v) return '';
      let vs = v.trim().split(' ');
      let m = _.find(m_opt, { value: vs[0] });
      let h = _.find(h_opt, { value: vs[1] });
      return (h && h.text || vs[1]) + ' ' + (m && m.text || vs[0]);
    }
  },
  computed: {
    is_using_login() {
      return this.model && this.model.el_submit != undefined && this.model.html != undefined
    },
    redir() {
      // console.log(`${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www')}/ToS`)
      return `${location.protocol}//${location.hostname == 'localhost' ? 'www.f1secaas.net' : location.hostname.replace('console.', 'www.')}/ToS`
    },
  },
  data : () => {
    return {
      modal_charge_agree : false,
      msg : '',
      modal_explain : false,
      del_nickname : '',
      codes,
      options : [],
      max_schedule : 10,
      policy : policy,
      v : {},
      isLoadPolicy : false,
      cc : undefined,
      policy_list : [],
      s : { schedule: '0 *', h: '*', h_opt: h_opt, m: '0', m_opt },
      del_confirm: false,
      del_name: false,
      add: false,
      lock: true,
      lock2 : false,
      group_list: undefined,
      model : default_model(),
      result : {},
      confirm_result : false
    }
  },
  methods: {
    // load recent result
    load_recent_result() {
      var search = {
        target: 'wmds.result',
        cmd : 'list',
        limit: 1,
        offset: 0,
        body: {
          and: [{ name : 'is_del', value: false, op : '='}, { name : 'site_id', value: this.model.id, op : '='}],
          or: [],
          sort: [{ name: 'id', op : 'desc'}]
        }
      }
      Api.Manager(search)
        .then(rs => { rs.body && rs.count > 0 ? this.result = rs.body[0] : {}; })
        .catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
    },
    go_result(id) { this.$router.push({ name : 'wmds_result', params : { id : id }}); },

    // ui method
    check_fqdn() {
      try {
        this.model.fqdn = _.trim(this.model.fqdn);
        if(!this.model.fqdn || !reg.domain.test(punycode.toASCII(this.model.fqdn))) { this.$refs.fqdn.$el.focus(); return this.$toastr.w('Domain Check'); }
        if(reg.prevent_domain.test(punycode.toASCII(this.model.fqdn))) { this.$refs.fqdn.$el.focus(); return this.$toastr.w('Domain Type Check'); }
        let seeds = this.model.config.seeds;
        if(!_.includes(seeds, 'http://' + this.model.fqdn) && !_.includes(seeds, 'https://' + this.model.fqdn)) {
          // seeds.push('http://' + );
          this.add_seed('http://' + this.model.fqdn)
        }
        let subs = this.model.config.subs;
        if(_.startsWith(this.model.fqdn, 'www.') && !_.includes(subs, this.model.fqdn.substr(4))) { subs.push(this.model.fqdn.substr(4)); }
        if(!this.model.name) {
          let vn = this.model.fqdn.split('.');
          this.model.name = _.startsWith(this.model.fqdn, 'www.') ? vn[1] : vn[0];
        }
      } catch (e) { console.error(e) }
    },

    // schedule
    schedule_filter: function (v) {
      if (!v) return '';
      // let vs = v.trim().split(' ');
      // let m = _.find(m_opt, { value: vs[0] });
      // let h = _.find(h_opt, { value: vs[1] });
      return `${v} * * *`
    },

    add_schedule() {
      if(!this.s.schedule) { return this.$toastr.w('select the schedule'); }
      let schedules = this.model.schedule;
      if(_.includes(schedules, this.s.schedule)) { this.s.schedule = undefined; return this.$toastr.i('Already existing'); }
      schedules.push(this.schedule_filter(this.s.schedule)); this.s.schedule = undefined;
      console.info("updated", schedules)
    },
    // TODO : 현재 미사용 처리됨
    // add_schedule_custom() {
    //   if(!this.s.schedule_custom) { return; }
    //   let schedules = this.model.schedule;
    //   if(_.includes(schedules, this.s.schedule_custom)) { this.s.schedule_custom = undefined; return this.$toastr.i('Already existing'); }

    //   // check cron grammar
    //   let arraySche = this.s.schedule_custom.split(' ');
    //   for (let l = 0; l < arraySche.length; l++) {
    //     const e = arraySche[l];
    //     let r = e.split(",")
    //     for (let k = 0; k < r.length; k++) {
    //       const rr = r[k];
    //       // if length is 5, have 5 at lest 6 *
    //       switch (arraySche.length > 4 ? l -1 : l) {
    //         case 0: !(rr <= 59 && rr > 0) ? this.$toastr.e("incorrect cron sec") : ''; break; // sec range 0 ~ 59
    //         case 1: !(rr <= 59 && rr > 0) ? this.$toastr.e("incorrect cron min") : ''; break; // min range 0 ~ 59
    //         case 2: !(rr <= 23 && rr > 0) ? this.$toastr.e("incorrect cron hour") : ''; break; // hour range 0 ~ 23
    //         case 3: !(rr <= 31 && rr > 0) ? this.$toastr.e("incorrect cron day of month") : ''; break; // day of month range 0 ~ 31
    //         case 4: !(rr <= 12 && rr > 0) ? this.$toastr.e("incorrect cron month") : ''; break; // month range 0 ~ 12
    //         case 5: !(rr <= 6 && rr > 0) ? this.$toastr.e("incorrect cron weekday") : ''; break; // weekday range 0 ~ 6
    //         default: console.log("not support "); break;
    //       }

    //     }

    //   }
    //   console.log(schedules, "good")
    //   // schedules.push(this.s.schedule_custom); this.s.schedule_custom = undefined;
    //   console.info("updated", schedules)
    // },
    remove_schedule(a) { this.model.schedule = Object.assign(_.without(this.model.schedule, a)); },

    // seed
    add_seed(url = '') {
      // console.log(this.v.seed, this.model.fqdn, this.v.seed.indexOf(this.model.fqdn) < 0)
      this.v.seed = url ? url : _.trim(this.v.seed);
      // if(!this.v.seed || this.v.seed.indexOf(this.model.fqdn) < 0) { return this.$toastr.w("Start URL does not contain FQDN") }
      let seeds = this.model.config.seeds;
      if(!reg.url_path.test(this.v.seed)) { return this.$toastr.e('URL Check'); }
      if(_.includes(seeds, this.v.seed)) { this.v.seed = undefined; return this.$toastr.i('Already existing'); }
      seeds.push(this.v.seed); this.v.seed = undefined;
    },
    remove_seed(a) { this.model.config.seeds = Object.assign(_.without(this.model.config.seeds, a)); },

    // subs
    add_sub() {
      this.v.sub = _.trim(this.v.sub);
      let subs = this.model.config.subs;
      if(!reg.domain.test(punycode.toASCII(this.v.sub))) { this.$refs.sub_domains.$el.focus(); return this.$toastr.e('Sub Domain Type Check'); }
      if(this.v.sub == this.model.fqdn) { this.v.sub = undefined; return this.$toastr.i('FQDN Check'); }
      if(_.includes(subs, this.v.sub)) { this.v.sub = undefined; return this.$toastr.i('Already existing'); }
      subs.push(this.v.sub); this.v.sub = undefined;
    },
    remove_sub(a) { this.model.config.subs = Object.assign(_.without(this.model.config.subs, a)); },
    add_prevent() {
      this.v.prevent = _.trim(this.v.prevent);
      let prevents = this.model.config.prevents;
      if(!reg.url_path.test(this.v.prevent)) { this.$refs.prevent.$el.focus(); return this.$toastr.e('URL Check'); }
      if(_.includes(prevents, this.v.prevent)) { this.v.prevent = undefined; return this.$toastr.i('Already existing'); }
      prevents.push(this.v.prevent); this.v.prevent = undefined;
    },
    remove_prevent(a) { this.model.config.prevents = Object.assign(_.without(this.model.config.prevents, a)); },
    schedule(e,t) { this.s.schedule = t == 'h' ? `${this.s.m} ${e}` : `${e} ${this.s.h}`; },
    cancel() { this.$router.replace({ name: 'wmds_site', params: { id: this.model.id }}); },
    edit() {
      this.$router.replace({ name: 'wmds_site', params: { id: this.$route.params.id, tag: 'edit' }});
      this.lock = true;
    },

    // site manage
    async remove() {
      try {
        this.del_nickname = (this.del_nickname || '').trim()
        if(this.model.name != this.del_nickname) { return this.$toastr.e('Invalid site name entered');  }
        this.del_nickname = '';
        this.del_confirm = false;
        let rs = await Api.Manager_Call('wmds.site','delete',{ id : this.model.id})
        if(rs.error) { return this.$toastr.e(this.$route.name, "failed") }
        this.$emit('refresh'); this.$toastr.s('Removed'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText), this.list() }
    },
    list() { this.$router.push({ name : 'wmds_site'}); },
    policy_manage() {  this.$router.replace({ name: 'wmds_policy', params: { id: this.model.policy_id }}); },
    async save() {
      let config = this.model.config;
      if(!this.model.policy_id) { this.$refs.policy.$el.focus(); return this.$toastr.e('Policy ' + 'Required value'); }
      if(!(this.model.fqdn || '').trim()) { this.$refs.fqdn.$el.focus(); return this.$toastr.e('FQDN ' + 'Required value'); }
      if(reg.prevent_domain.test(punycode.toASCII(this.model.fqdn))) { return this.$toastr.e('Domain Type Check'); }
      if(!this.model.schedule.length) { this.$refs.schedule.$el.focus(); return this.$toastr.e('plz, Add Schedule'); }
      if(!config.seeds.length) { return this.$toastr.e('Check start URL Check'); }

      try {
        let rs = await Api.Manager_Call('wmds.site', this.model.id ? 'update' : 'insert', this.model);
        if(rs.error) { return this.$toastr.e("saved failed") }
        this.$toastr.s('Saved'); this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText)  }
      this.lock = true;
    },
    async change(index){
      try {
        let rs = await Api.Manager({ target : 'policy', cmd : 'detail', body : { id : index }});
        if(rs.error) { return this.$toastr.e("policy load failed") }

        this.policy = rs.body.policy;
        this.policy.description =this.policy.description ? this.policy.description : rs.body.description
        this.model.policy_id = index
        this.isLoadPolicy = true

        console.log("reload", this.policy.description)
      } catch (e) { console.log(e) }
    },
    async get({ id, tag } = this.$route.params) {
      // this part change dynamic loding
      this.add = false;
      let so = {
        target : 'wmds.policy', cmd : 'list',
        body : { sort : [{name : 'id', op : 'desc'}], or : [], and : [{ name : "is_del", value : false, op : '='}] },
      }
      let rs = await Api.Manager(so);
      if(rs.error) { return this.$toastr.e("load failed") }
      this.policy_list = (rs.body || []).map(r => {
        r.description = r.description
        if(r.description == undefined) { r.description = r.policy.description }
        // console.log(r, 'r')
        return r
      })

      this.lock = (tag !== 'edit');

      if(id == 'add') { this.add = true; this.lock = false; return; }

      let checkPolicyList = _.map(this.policy_list, r => { return r.id })
      this.model = Object.assign({ group: {} }, this.model, (await Api.Manager_Call('wmds.site', 'detail', { id : id })).body);

      if(checkPolicyList.includes(this.model.policy_id)){
        let result = await Api.Manager_Call('wmds.policy', 'detail', { id : this.model.policy_id });
        if(result.error) { return this.$toastr.e("load failed") }

        this.policy = Object.assign({}, this.policy, result.body.policy, { description : result.body.description })
        if(this.policy.description == undefined) { this.policy.description = result.body.policy.description }
        this.isLoadPolicy = true;
      }
      this.load_recent_result()
    },
    refresh() { this.$emit('refresh') },
    async charge_agree() {
      try {
        let rs = await Api.Manager_Call('wmds.site', 'agree', { ts : new Date().getTime() });
        if(rs.error) { return this.$toastr.e("apply agreement failed") }
        // 시스템 로그가 남아야 함, 동의 부분 관련
        this.save()
      } catch (e) { console.log(e); this.$toastr.e("apply agreement failed") }

    },
  },
  watch: { '$route' (to, from) { this.get(to.params); console.log(from.path) } },
  created: function() { console.log('site.detail.vue', 'created'); },
  destroyed: function() { console.log('site.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('site.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
